<template>
  <div class="official-event full-page-container white-container">
    <el-button size="small" type="primary" icon="el-icon-plus" style="position: absolute;top: -50px;right: 0;" @click="add">新增</el-button>
    <el-form class="search-bar" :inline="true" size="small">
      <el-form-item class="search-form-item">
        <el-input v-model="search.name" placeholder="请输入你想搜索文字" prefix-icon="el-icon-search" />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="searchSubmit">查询</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>
      <el-form-item label="活动城市：">
        <el-select ref="cityBox" v-model="search.region" placeholder="城市">
          <el-option label="全国" value="" />
          <el-option v-for="item in cityList" :key="item" :label="item" :value="item" />
        </el-select>
      </el-form-item>

      <!-- <el-form-item label="活动城市：">
        <el-cascader v-model="selectedRegion" :options="cityOptions" placeholder="全国" clearable />
      </el-form-item> -->

      <el-form-item label="活动状态：">
        <el-select ref="statusBox" v-model="search.status" placeholder="选择活动状态">
          <el-option label="全部" value="" />
          <el-option v-for="item in statusList" :key="item.id" :label="item.value" :value="item.id" />
        </el-select>
      </el-form-item>

    </el-form>
    <el-table ref="multipleTable" size="small" :data="list" style="width: 100%">
      <el-table-column prop="id" label="活动ID" width="100" fixed />
      <el-table-column prop="name" label="活动标题" width="auto" min-width="160" />
      <el-table-column prop="status" label="活动状态" width="160">
        <template v-slot="scope">
          <el-tag v-if="scope.row.status === 0" class="el-tag--yellow" size="mini">草稿</el-tag>
          <el-tag v-if="scope.row.status === 1" class="el-tag--blue" size="mini">已发布</el-tag>
          <el-tag v-if="scope.row.status === 2" class="el-tag--green" size="mini">开放报名中</el-tag>
          <el-tag v-if="scope.row.status === 3" class="el-tag--gray" size="mini">报名截止</el-tag>
          <el-tag v-if="scope.row.status === 4" class="el-tag--end" size="mini">已结束</el-tag>
        </template>
      </el-table-column>

      <el-table-column prop="beginTime" label="活动日期" width="180">
        <template #default="{row}">
          <!-- {{ $moment(row.beginTime).format('YYYY/MM/DD') || '--' }} -->
          {{ row.beginTime }}
        </template>
      </el-table-column>
      <el-table-column prop="region" label="活动城市" width="160" />
      <el-table-column prop="newParticipationNumber" label="报名队伍" width="100">
        <template #default="{row}">
          {{ row.teamParticipation }}/{{ row.maxTeam }}
        </template>
      </el-table-column>

      <el-table-column fixed="right" width="490px" label="操作">
        <template v-slot="{row}">
          <el-button v-if="row.status === 0" size="small" type="text" class="link-color" @click="publish(row)">发布</el-button>
          <el-button v-if="row.status === 0 || row.status === 1" size="small" type="text" class="link-color" @click="gotoEdit(row)">编辑</el-button>
          <el-button v-if="row.status === 2 || row.status === 3 || row.status === 4" size="small" type="text" class="link-color" @click="downNameList(row)">下载报名名单</el-button>
          <el-button v-if="row.status === 2 || row.status === 3 || row.status === 4" size="small" type="text" class="link-color" @click="downIdentityInformation(row)">身份证信息表</el-button>
          <el-button v-if="row.status === 3" size="small" type="text" class="link-color" @click="uploadUserData(row)">上传球队名单</el-button>
          <!-- <el-button size="small" type="text" class="link-color" @click="handleLook(row)" v-if="row.status === 4">上传球队数据</el-button> -->
          <!-- <el-button size="smallfuploadUserData" type="text" class="link-color" @click="downQrCode(row)" v-if="row.status === 2 || row.status === 3 || row.status === 4">下载签到码</el-button> -->
          <el-popover v-if="row.status === 2 || row.status === 3 || row.status === 4" placement="bottom" width="148" style="margin:0 10px" trigger="click" :popper-options="{ removeOnDestroy: true }">
            <div style="text-align:center">
              <img :ref="`downLoadImg${row.id}`" src="" alt="" style="width:100%;">
              <el-button size="small" type="text" class="link-color" @click="downQrCode(row)">下载签到码</el-button>
            </div>
            <el-button slot="reference" size="small" type="text" class="link-color" @click="getErcode(row)">签到码</el-button>
          </el-popover>
          <el-button size="small" type="text" class="link-color" @click="deleteActivity(row)">删除</el-button>
          <el-button size="small" type="text" class="link-color" @click="copy(row)">复制</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background class="fixed-below" :page-size="currentPage.limit" :page-sizes="[10, 20, 50, 100]" :current-page.sync="currentPage.current" :total="currentPage.total" layout="total, prev, pager, next, sizes" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="dialogSuccess" />
    <!-- 弹窗 -->
    <el-dialog v-if="importDialogShow" :visible="importDialogShow" :title="dialogTitle" custom-class="share-wrapper" @close="handleCloseImport">
      <div class="upload-wrapTop">
        <div class="tips">下载导入模板，根据模板完善内容</div>
        <div class="coupon_tip" @click="downloadFileTemplate">
          <i class="el-icon-document" />下载文件模板
        </div>
      </div>
      <div class="upload-wrap">
        <div class="tips">上传完善好的表格，仅支持上传*.xls、*.xlsx格式</div>
        <el-upload class="upload-box" drag action="" :show-file-list="false" :on-change="handlePushUploader" :auto-upload="false">
          <div>
            <div style="height: 50px">
              <svg-icon icon-class="xls" style="width: 50px; height: 50px" />
            </div>
            <el-button v-if="!classExcel" size="small">选择文件</el-button>
            <template v-else>
              <div class="file">{{ classExcel.name }}</div>
              <el-button size="small">重新选择</el-button>
            </template>
          </div>
        </el-upload>
      </div>
      <div class="flex btns">
        <el-button type="info" @click="handleCloseImport">取消</el-button>
        <el-button type="primary" @click="uploadSubmit">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Dialog from '@/components/Dialog';
import { getFileType } from "@/common/js/util";
export default {
  components: { Dialog },
  data() {
    return {
      search: {
        region: null,
        name: null,
        status: null,
      },
      cityList: [],
      statusList: [
        {
          value: '草稿',
          id: 0,
        },
        {
          value: '已发布',
          id: 1,
        },
        {
          value: '开放报名中',
          id: 2,
        },
        {
          value: '报名截止',
          id: 3,
        },
        {
          value: '已结束',
          id: 4,
        },
      ],
      list: [],
      currentPage: {
        current: 1,
        limit: 10,
        total: 0,
      },
      searchSubmitted: {},
      information: {},
      id: '',
      formDialogShow: false,
      importDialogShow: false,
      classExcel: null,
      currentID: '',
    };
  },
  mounted() {
    this.$Api.rugby.officialActivityCity().then(res => {
      this.cityList = res;
      console.log(res.data);
    });
    this.getList();
  },
  beforeRouteLeave(to, from, next) {
    const list = ['/rugby/officialEvent/edit'];
    if (!list.includes(to.path)) {
      this.enter = 0;
      this.searchSubmitted = {};
      this.search = {
        region: null,
        name: null,
        status: null,
      };
      this.pageNum = 1;
    }
    next();
  },
  methods: {
    add() {
      this.$router.push({ path: '/rugby/officialEvent/add' });
    },
    gotoEdit(row) {
      this.$router.push({
        path: '/rugby/officialEvent/edit',
        query: {
          id: row.id,
        },
      });
    },
    uploadUserData(row) {
      this.currentID = row.id;
      this.importDialogShow = true;
      this.dialogTitle = "上传球队名单";
    },
    copy(row) {
      this.formDialogShow = true;
      this.currentID = row.id;
      this.information = {
        operation: "copy",
        icon: "success",
        subTitle: `复制成功！是否进入新增页面？`,
      };
    },
    handlePushUploader(file) {
      if (getFileType(file.raw.name) !== "excel") {
        this.$message.error("导入失败，请选择Excel文件");
        return;
      }
      console.log(file.raw);
      this.classExcel = file.raw;
    },
    handleCloseImport() {
      this.importDialogShow = false;
      this.classExcel = null;
    },
    downloadFileTemplate() {
      const fileUrl =
        "https://uaprd-1257321318.cos.ap-beijing.myqcloud.com/static/image/Football/FlagUploadTheTeamList.xlsx";
      window.open(fileUrl);
    },
    uploadSubmit() {
      if (!this.classExcel) {
        this.$message.warning("请先选择文件");
        return;
      }
      const formData = new FormData();
      formData.append("file", this.classExcel);
      formData.append("id", this.currentID);
      this.$Api.rugby.officialActivityUploadTheTeamList(formData).then(res => {
        this.$message.success("导入成功");
        this.getList();
        this.handleCloseImport();
      });
    },
    downNameList(row) {
      this.$Api.rugby.officialActivityExportEnrollmentList(row.id).then(res => {
        if (!res) {
          this.$message.error("暂无数据");
        } else {
          this.$message.success("导出成功");
        }
      });
    },
    downIdentityInformation(row) {
      this.$Api.rugby.officialActivityExampleExportTheIDCardInformationTable(row.id).then(res => {
        if (!res) {
          this.$message.error("暂无数据");
        } else {
          this.$message.success("导出成功");
        }
      });
    },
    deleteActivity(row) {
      this.formDialogShow = true;
      this.information = {
        operation: 'delete',
        icon: 'warn',
        subTitle: `是否删除该活动？`,
      };
      this.id = row.id;
    },
    publish(row) {
      this.formDialogShow = true;
      this.information = {
        operation: 'publish',
        icon: 'warn',
        subTitle: `是否发布该活动？`,
      };
      this.id = row.id;
    },
    dialogSuccess() {
      if (this.information.operation && this.information.operation === 'publish') {
        this.$Api.rugby.officialActivityPublish({ id: this.id }).then(res => {
          this.getList();
        });
      } else if (this.information.operation && this.information.operation === 'delete') {
        this.$Api.rugby.officialActivityDelate(this.id).then(res => {
          this.getList();
        });
      } else if (this.information.operation && this.information.operation === 'copy') {
        this.$router.push({
          path: "/rugby/officialEvent/add",
          query: { copyId: this.currentID },
        });
      }
    },
    // 查询
    searchSubmit() {
      this.searchSubmitted = {};
      Object.keys(this.search).forEach(key => {
        this.searchSubmitted[key] = this.search[key];
      });
      // if (this.selectedRegion.length > 0) {
      //   this.searchSubmitted.region = this.selectedRegion.join(' / ');
      // }

      this.currentPage.current = 1;
      this.getList();
    },
    reset() {
      this.searchSubmitted = {};
      this.search = {
        region: null,
        name: null,
        status: null,
      };
      this.currentPage.current = 1;
      this.getList();
    },
    handleSizeChange(value) {
      this.currentPage.limit = value;
      this.getList();
    },
    handleCurrentChange(value) {
      this.currentPage.current = value;
      this.getList();
    },
    getList() {
      this.$Api.rugby.officialActivityList({ ...this.currentPage, ...this.searchSubmitted }).then(res => {
        this.currentPage.total = res.total;
        this.list = res.data;
      });
    },
    // 下载二维码
    downQrCode(row) {
      // 创建a链接下载
      const link = document.createElement('a');
      link.href = this.$refs[`downLoadImg${row.id}`].src;
      link.download = `${row.name}.png`;
      link.target = '_blank';
      link.click();
    },
    getErcode(row) {
      this.$Api.rugby.officialActivityQrcode(row.id).then((res) => {
        this.$refs[`downLoadImg${row.id}`].src = res;
      });
    },
  },
};
</script>
<style lang="less" scoped>
.el-tag {
  font-size: 14px;
  font-weight: 400;
}
.el-tag.el-tag--yellow {
  background-color: #fcf5e9;
  border-color: #ebb45a;
  color: #d38d15;
}

.el-tag.el-tag--green {
  background-color: #f1f7ef;
  border-color: #92c382;
  color: #6bac53;
}

.el-tag.el-tag--blue {
  background-color: #dde7f2;
  border-color: #65b0ff;
  color: #3791ff;
}
.el-tag.el-tag--end {
  background-color: #ededed;
  border-color: #b5b5b5;
  color: #9b9b9b;
}
.el-tag.el-tag--gray {
  background-color: #dbdbdb;
  border-color: #afafaf;
  color: #9b9b9b;
}
.el-dialog__wrapper {
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/ .share-wrapper {
  width: 538px;
  margin: unset !important;
  .el-dialog__header {
    height: 6.85vh !important;
    line-height: 6.85vh;
    padding: 0 2.87vh 0 2.78vh !important;
    background: #000000 !important;
    box-sizing: border-box !important;
    .el-dialog__title {
      font-family: "Noto Sans SC";
      font-style: normal;
      font-weight: 500;
      font-size: 1.48vh;
      color: #ffffff;
    }
    .el-dialog__headerbtn {
      top: 2.87vh;
      right: 2.87vh;
      font-size: 1.11vh;
      .el-dialog__close {
        color: #ffffff;
        &:hover {
          color: #dc0019;
        }
      }
    }
  }
  .el-dialog__body {
    padding: 30px;
    .upload-wrapTop {
      width: 100%;
      height: 114px;
      background: #f7f7f7;
      border: 1px dashed #bbbbbb;
      border-radius: 4px;
      margin-bottom: 20px;
      padding: 20px 30px;
      > .tips {
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #494949;
        margin-bottom: 20px;
      }
      > .coupon_tip {
        cursor: pointer;
        user-select: none;
        width: 130px;
        height: 34px;
        background: #ffffff;
        border: 1px solid #bbbbbb;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        line-height: 20px;
        color: #000000;
        > i {
          margin-right: 7px;
        }
      }
      > .coupon_tip:hover {
        background: #f7f7f7;
        color: #afafaf;
      }
    }
    .upload-wrap {
      width: 100%;
      height: 250px;
      background: #f7f7f7;
      border: 1px dashed #bbbbbb;
      border-radius: 4px;
      padding: 20px 30px;
      box-sizing: border-box;
      .el-input__inner {
        height: 34px !important;
      }
      .el-upload-dragger {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .tips {
        font-family: "Noto Sans SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #494949;
        margin-bottom: 20px;
      }
      .upload-box {
        width: 100%;
        height: 156px;

        .el-upload.el-upload--text {
          width: 100%;
          height: 100%;
          .el-upload-dragger {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            border: 1px solid #bbbbbb;
            border-radius: 4px;
            &:hover {
              border-color: #1c1c1c;
            }
            .file {
              line-height: 20px;
              margin-top: 5.68px;
            }
            .el-button {
              margin-top: 10px;
            }
          }
        }
      }
    }
  }
  .activity-num {
    justify-content: center;
    font-size: 48px;
    color: #000000;
  }
  .btns {
    justify-content: center;
    margin-top: 30px;
    .el-button {
      width: 120px;
      height: 50px;
    }
    .el-button + .el-button {
      margin-left: 30px;
    }
  }
}
</style>
